<template>
  <p class="entry-meta">
    Restez
    <Flash/>
    pour plus de <a href="https://www.youtube.com/channel/UC1v0FLUt1lO_DUZ7DPN91vA" target="_blank">vidéos</a> et de
    <a href="https://www.instagram.com/go2roues/" target="_blank">photos</a>
    <!--    <a href="https://www.youtube.com/channel/UC1v0FLUt1lO_DUZ7DPN91vA">-->
    <!--      <Youtube fill="#00ccd1" title="Youtube GO2ROUES" />-->
    <!--    </a>-->
    <!--    <a href="https://www.instagram.com/go2roues/">-->
    <!--      <Instagram fill="#00ccd1" title="Instagram GO2ROUES"/>-->
    <!--    </a>-->
  </p>
</template>
<script>
import Facebook from "@/components/icons/social/Facebook";
import Flash from "@/components/icons/Flash";
import Youtube from "@/components/icons/social/Youtube";
import Instagram from "@/components/icons/social/Instagram";

export default {
  name: "RestezBranche",
  components: {Instagram, Youtube, Flash, Facebook},
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 768px) {
  .entry-meta {
    border-top: none;
  }
}

.entry-meta {
  display: flex;
  align-items: center;

  a {
    margin: 0 .5rem;

    &:last-child {
      margin: 0 0 0 .5rem;
    }
  }

  svg {
    margin: 0 .5rem;
  }
}

@media screen and (min-width: 768px) {
  .entry-meta {
    justify-content: flex-end;
  }
}
</style>
